
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.PasswordMessage_2b2ef4ead4e23f4c{color:var(--color_45c0f58f3d5b05b4)}.DefaultIcon_8f5ac13970851b4d,.InvalidIcon_ade51793329c1202,.ValidIcon_c70829a659cbd140{display:inline-block;width:14px;height:14px;vertical-align:middle;margin-right:2px}`;
styleInject(_css)

/** PasswordMessage Props */
export type PasswordMessageCCM = {
  /** PasswordMessage Component Custom Properties */
  '$color': string;

  /** PasswordMessage Modifier Flags */
  // No modifiers classes found
};
/** Base PasswordMessage component */
export const PasswordMessage: ComponentCreator<PasswordMessageCCM> = createComponentCreator({
  "name": "PasswordMessage",
  "base": "PasswordMessage_2b2ef4ead4e23f4c",
  "prop": {
    "$color": "--color_45c0f58f3d5b05b4"
  },
  "mod": {}
});


/** InvalidIcon Props */
export type InvalidIconCCM = {
  /** InvalidIcon Component Custom Properties */
  // No custom properties found

  /** InvalidIcon Modifier Flags */
  // No modifiers classes found
};
/** Base InvalidIcon component */
export const InvalidIcon: ComponentCreator<InvalidIconCCM> = createComponentCreator({
  "name": "InvalidIcon",
  "base": "InvalidIcon_ade51793329c1202",
  "prop": {},
  "mod": {}
});


/** ValidIcon Props */
export type ValidIconCCM = {
  /** ValidIcon Component Custom Properties */
  // No custom properties found

  /** ValidIcon Modifier Flags */
  // No modifiers classes found
};
/** Base ValidIcon component */
export const ValidIcon: ComponentCreator<ValidIconCCM> = createComponentCreator({
  "name": "ValidIcon",
  "base": "ValidIcon_c70829a659cbd140",
  "prop": {},
  "mod": {}
});


/** DefaultIcon Props */
export type DefaultIconCCM = {
  /** DefaultIcon Component Custom Properties */
  // No custom properties found

  /** DefaultIcon Modifier Flags */
  // No modifiers classes found
};
/** Base DefaultIcon component */
export const DefaultIcon: ComponentCreator<DefaultIconCCM> = createComponentCreator({
  "name": "DefaultIcon",
  "base": "DefaultIcon_8f5ac13970851b4d",
  "prop": {},
  "mod": {}
});

